import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip } from "bootstrap";
import { observer } from "mobx-react-lite";
import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { OAuthViewModel } from "../../features/oauth/oauth-viewmodel";
import { useViewModel } from "../../viewmodel/use-view-model";
export var ProtectedMode;
(function (ProtectedMode) {
    ProtectedMode["DISABLE"] = "disable";
    ProtectedMode["HIDE"] = "hide";
})(ProtectedMode || (ProtectedMode = {}));
export const RoleProtectedAction = observer(({ allowedRoles, children, mode, reason }) => {
    const oauthVM = useViewModel(OAuthViewModel);
    const { t } = useTranslation();
    const isAllowed = oauthVM.hasAnyRole(allowedRoles);
    // store a single tooltip instance per component instance
    const tooltipRef = useRef(null);
    // track the pending auto-hide timer so it can be cleared on unmount
    const hideTimeoutRef = useRef(null);
    // dispose tooltip on unmount
    useEffect(() => {
        return () => {
            if (hideTimeoutRef.current !== null) {
                clearTimeout(hideTimeoutRef.current);
                hideTimeoutRef.current = null;
            }
            tooltipRef.current?.dispose();
            tooltipRef.current = null;
        };
    }, []);
    if (isAllowed) {
        return children;
    }
    if (mode === ProtectedMode.HIDE) {
        return null;
    }
    const tooltipText = reason ?? t("user.access.disabled");
    const disabledChild = React.cloneElement(children, {
        disabled: true
    });
    return (_jsx("span", { title: tooltipText, onClick: (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (!tooltipRef.current) {
                tooltipRef.current = new Tooltip(e.currentTarget, { trigger: "manual" });
            }
            tooltipRef.current.show();
            if (hideTimeoutRef.current !== null) {
                clearTimeout(hideTimeoutRef.current);
            }
            hideTimeoutRef.current = setTimeout(() => {
                tooltipRef.current?.hide();
                hideTimeoutRef.current = null;
            }, 1500);
        }, style: { cursor: "not-allowed", display: "inline-block" }, children: disabledChild }));
});
